import React from 'react';

export interface IEndpoint {
  key: string;
  endpointURL: string;
}

export interface IAPIPackage {
  // authGuard: (route: IRoute, user: User | null) => boolean; old definition
  // authGuard: (routeName - for manual toggling from shell and no other use, licenseKey/priveledgekey) => boolean; new definition
  baseURL: string;
  authFetch: (
    input: RequestInfo,
    init?: RequestInit | undefined
  ) => Promise<Response>;
  offering: string;
}

interface IAPIProviderProps {
  children: React.ReactElement;
  APIPackage: IAPIPackage;
}

export const APIContext = React.createContext<IAPIPackage>({
  // authGuard: () => true,
  baseURL: 'No context',
  authFetch: (input: RequestInfo) => {
    return new Promise<Response>((resolve, reject) => reject('No context'));
  },
  offering: 'No context'
});

/**
 * !
 * This needs to be updated for strong typing
 * Currently this turns the type of any component to any, which stops any prop type safety when consumed, meaning
 * its very easy to get props wrong when using any component that uses APIs
 */
export const consumeAPIs = (Component: any) => {
  return (props: any) => (
    <APIContext.Consumer>
      {value => <Component {...props} {...value} />}
    </APIContext.Consumer>
  );
};

// class MyComponent extends React.Component<{ foo: number }> {
//   render() {
//     return this.props.foo;
//   }
// }

// consumeAPIs(MyComponent);

// const myFuncComponent = (props: { foo: number }) => {
//   return <>{props.foo}</>;
// };

// consumeAPIs(myFuncComponent);

export const APIProvider = (props: IAPIProviderProps) => {
  return (
    <APIContext.Provider value={props.APIPackage}>
      {props.children}
    </APIContext.Provider>
  );
};
